export function bindBoardCardReviewDetailsClick(toggle: HTMLButtonElement, onClick: (event: MouseEvent) => void): void {
    toggle.addEventListener("click", onClick);
}

export function bindBoardCardReviewDetailsTransitionEnd(
    body: HTMLElement,
    onTransitionEnd: (event: TransitionEvent) => void,
): void {
    body.addEventListener("transitionend", onTransitionEnd);
}

export function unbindBoardCardReviewDetailsTransitionEnd(
    body: HTMLElement,
    onTransitionEnd: (event: TransitionEvent) => void,
): void {
    body.removeEventListener("transitionend", onTransitionEnd);
}
